import MagnifyingGlassThick from '../src/MagnifyingGlassThick';
export default MagnifyingGlassThick;
